import Vue from 'vue'
import Cookies from 'js-cookie'
import { ENABLE_OPTIMIZER_DEBUG_SIDEBAR } from '@/features'
import $models from '@/models' //??

/*
Helper function that return an object from local storage or a default value
*/
function localStorageGetWithDefault(key, default_value) {
  var value = localStorage.getItem(key);
  if ( value === null ) {
    return default_value;
  }
  return JSON.parse(value);
}

function localStorageSet(key, value) {
  return localStorage.setItem(key, value);
}

// TODO: Split
function initialState() {
  return {
    flexGridEnabled: false,
    sidebar: {
      opened: Cookies.get('sidebarStatus') === undefined ? true : !!+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    dayplanner_sidebar: !!+Cookies.get('dayplannerSidebarStatus'),
    sessionbar: {
      opened: !!+Cookies.get('sessionbarStatus'),
    },
    debugtool: {
      show: !+Cookies.get('debugtoolStatus') && ENABLE_OPTIMIZER_DEBUG_SIDEBAR,
    },
    device: 'desktop',
    size: Cookies.get('size') || 'medium',
    visionboardPreviewBase64: null,
    kanban_scroll_position: 0,
    visionboard_edit_mode: false,
    visionboard_challenge_sidebar: false,
    show_debug: !!+Cookies.get('debug.show'),
    disable_optimizer: !!+Cookies.get('debug.disable-optimizer'),
    intro: {
      // true = show, false = hide
      dayplanner_drag: localStorageGetWithDefault('intro.dayplanner_drag', true)
      // ...
    },
    active_topbar_menu: null,
    active_sidebar_menu: 'TODAY', // default
    active_user_chat: null,
  }
}

export default {
  namespaced: true,

  state: initialState(),

  getters: {
    flexGridEnabled: ({ flexGridEnabled }) => flexGridEnabled,
    sidebar: state => state.sidebar,
    dayplanner_sidebar: state => state.dayplanner_sidebar,
    sessionbar: state => state.sessionbar,
    debugtool: state => state.debugtool,
    device: state => state.device,
    size: state => state.size,
    kanban_scroll_position: state => state.kanban_scroll_position,
    visionboardPreview: state => {
      let img = new Image();
      img.src = state.visionboardPreviewBase64 || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII='; /* 1x1 black pixel */
      return img;
    },
    visionboard_edit_mode: state => state.visionboard_edit_mode,
    visionboard_challenge_sidebar: state => state.visionboard_challenge_sidebar,
    SHOW_DEBUG: (state) => state.show_debug,
    OPTIMIZER_DISABLE: (state) => state.disable_optimizer,
    active_topbar_menu: (state) => state.active_topbar_menu,
    active_sidebar_menu: (state) => state.active_sidebar_menu,
    active_user_chat: (state) => state.active_user_chat,
    intro: (state) => state.intro,

    user_get_language: () => {
      // TODO: Used by watcher
      return $models.userSettings.getters.user_get_language
    },

    user_get_dateformat: () => {
      // TODO: Used by watcher
      return $models.userSettings.getters.user_get_dateformat;
    },

    user_get_timezone: () => {
      // TODO: Used by watcher
      return $models.userSettings.getters.user_get_timezone;
    },
  },

  mutations: {
    SET_FLEXGRID(state, enabled) {
      state.flexGridEnabled = enabled;
    },

    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 0)
      } else {
        Cookies.set('sidebarStatus', 1)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },

    SET_DAYPLANNER_SIDEBAR_STATE(state, value) {
      Cookies.set('dayplannerSidebarStatus', value ? 1 : 0)
      state.dayplanner_sidebar = value;
    },

    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },

    TOGGLE_SESSIONBAR: state => {
      if (state.sessionbar.opened) {
        Cookies.set('sessionbarStatus', 0)
      } else {
        Cookies.set('sessionbarStatus', 1)
      }
      state.sessionbar.opened = !state.sessionbar.opened
    },

    TOGGLE_DEBUGBAR: state => {
      Cookies.set('debugtoolStatus', state.debugtool.show ? 1 : 0)
      if ( ENABLE_OPTIMIZER_DEBUG_SIDEBAR ) {
        state.debugtool.show = !state.debugtool.show
      }
    },

    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },

    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },

    SET_KANBAN_SCROLL_POSITION(state, pos) {
      state.kanban_scroll_position = pos;
    },

    SET_VISIONBOAR_PREVIEW_BASE64(state, blob) {
      state.visionboardPreviewBase64 = blob;
    },

    TOGGLE_VISIONBOARD_EDIT_MODE(state) {
      state.visionboard_edit_mode = !state.visionboard_edit_mode;
    },

    TOGGLE_VISIONBOARD_CHALLENGE_SIDEBAR(state) {
      state.visionboard_challenge_sidebar = !state.visionboard_challenge_sidebar;
    },

    DISABLE_VISIONBOARD_EDIT_MODE(state) {
      state.visionboard_edit_mode = false
    },

    DISABLE_VISIONBOARD_CHALLENGE_SIDEBAR(state) {
      state.visionboard_challenge_sidebar = false
    },

    SET_DEBUG(state, value) {
      Cookies.set('debug.show', value ? 1 : 0)
      state.show_debug = value;
    },

    SET_OPTIMIZER_DISABLE(state, value) {
      Cookies.set('debug.disable-optimizer', 1 * value )
      state.disable_optimizer = value;
    },

    SET_ACTIVE_TOPBAR_MENU( state, value ) {
      state.active_topbar_menu = value
    },

    SET_ACTIVE_SIDEBAR_MENU( state, value ) {
      state.active_sidebar_menu = value
    },

    SET_ACTIVE_USER_CHAT( state, value ) {
      state.active_user_chat = value
    },

    SET_INTRO_FLAG: (state, { flag, show }) => {
      if ( ![ 'dayplanner_drag' ].includes(flag) ) {
        throw new Error('Invalid flag: ' + flag)
      }
      Vue.set(state.intro, flag, show);
      localStorageSet('intro.' + flag, show)
    },

    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },

  actions: {

    goToChat({ commit }, { contactId }) {
      commit('SET_ACTIVE_SIDEBAR_MENU', 'CHAT' )
      commit('SET_ACTIVE_USER_CHAT', contactId )
    },

    setDayplannerSidebar({ commit }, value) {
      commit('SET_DAYPLANNER_SIDEBAR_STATE', value);
    },

    toggleSessionBar({ commit }) {
      commit('TOGGLE_SESSIONBAR')
    },

    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },

    toggleDebugBar({ commit }) {
      commit('TOGGLE_DEBUGBAR')
    },

    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },

    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },

    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    },

    setVisionboardPreviewBase64({ commit }, blob) {
      commit('SET_VISIONBOAR_PREVIEW_BASE64', blob)
    },

    toggleVisionboardEditMode({ commit }) {
      commit('DISABLE_VISIONBOARD_CHALLENGE_SIDEBAR')
      commit('TOGGLE_VISIONBOARD_EDIT_MODE')
    },

    toggleVisionboardChallengeSidebar({ commit }) {
      commit('DISABLE_VISIONBOARD_EDIT_MODE')
      commit('TOGGLE_VISIONBOARD_CHALLENGE_SIDEBAR')
    },

    hideIntro({ commit }, flag) {
      commit('SET_INTRO_FLAG', { flag, show: false })
    },

    showIntro({ commit }, flag) {
      commit('SET_INTRO_FLAG', { flag, show: true })
    },
  },
}

if ( process.env.VUE_APP_PRODUCTION === 'false' ) {
  window.gpdev = Object.assign(window.gpdev, {
    Cookies
  });
}
